export { default as useCourseDetail } from './useCourseDetail';
